module.exports = __webpack_public_path__ + "static/media/star.6bb660df.svg";